<button
  *ngIf="!this._subject.archived"
  color="secondary"
  mat-menu-item
  id="visualize_widget"
  aria-label="Visualise Subject Links"
  matTooltip="Visualise Subject Links"
  (click)="showVisualize()"
>
  <mat-icon>account_tree</mat-icon>
  <span aria-label="Visualise Subject Links">{{ this.text }}</span>
</button>

<button
  *ngIf="this._subject.archived"
  color="secondary"
  mat-button
  id="visualize_widget"
  aria-label="Visualise Subject Links"
  matTooltip="Visualise Subject Links"
  (click)="showVisualize()"
>
  <mat-icon>account_tree</mat-icon>
  <span aria-label="Visualise Subject Links">{{ this.text }}</span>
</button>
